{
  "version": 1,
  "asset_id": "28d1a6f4-dfb3-4ea3-9fc8-bcfda25430da",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/28d1a6f4-dfb3-4ea3-9fc8-bcfda25430da/astps.png",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/28d1a6f4-dfb3-4ea3-9fc8-bcfda25430da/astps.png",
  "original_filename": "astps.png",
  "size": 4333,
  "content_type": "image/png",
  "created_at": "2026-06-26T14:25:32Z"
}
